import { c as _c } from "react/compiler-runtime";
import { CollectionLockup } from "@opensea/app-kit";
import { readFragment } from "@opensea/graphql";
import { classNames, TableCell, TableRow, TextBody } from "@opensea/ui-kit";
import { Volume } from "@/components/price/Volume";
import { ProfilePreviewTooltipCollectionTableRowFragment } from "./ProfilePreviewTooltipCollectionTable.fragment";
import { TABLE_ROW_CLASS_NAMES, tableRowColumns } from "./utils";
export function ProfilePreviewTooltipCollectionTableRow(t0) {
  const $ = _c(18);
  const {
    item: itemKey,
    className
  } = t0;
  let t1;
  if ($[0] !== itemKey) {
    t1 = readFragment(ProfilePreviewTooltipCollectionTableRowFragment, itemKey);
    $[0] = itemKey;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const item = t1;
  if (!item) {
    return;
  }
  let t2;
  if ($[2] !== className) {
    t2 = classNames(TABLE_ROW_CLASS_NAMES, className);
    $[2] = className;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = tableRowColumns.collection();
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== item.collection) {
    t4 = <TableCell className={t3}><CollectionLockup collection={item.collection} size="xs" /></TableCell>;
    $[5] = item.collection;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = tableRowColumns.held();
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== item.ownership.totalQuantity) {
    t6 = <TableCell className={t5}><TextBody>{item.ownership.totalQuantity}</TextBody></TableCell>;
    $[8] = item.ownership.totalQuantity;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = tableRowColumns.value();
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== item.ownership.value) {
    t8 = <TableCell className={t7}><Volume display="compact" volume={item.ownership.value} /></TableCell>;
    $[11] = item.ownership.value;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t2 || $[14] !== t4 || $[15] !== t6 || $[16] !== t8) {
    t9 = <TableRow className={t2}>{t4}{t6}{t8}</TableRow>;
    $[13] = t2;
    $[14] = t4;
    $[15] = t6;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  return t9;
}